import React, { useState, useEffect } from "react";
import Help_CTA from "../Home/Help_CTA";
import Modal_started from "../Home/Modal_started";
import useDocumentTitle from "../../useDocumentTitle";

import { ThreeDots } from "react-loader-spinner";

import { useTranslation } from "react-i18next";

import { Link, useLocation } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";

const BlogCL = () => {
  useDocumentTitle("Invu POS | Blog Resources");

  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedTypeContent, setSelectedTypeContent] = useState("All");
  const [selectedCountry, setSelectedCountry] = useState("All");
  const [filteredData, setFilteredData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [showResults, setShowResults] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleFilterButtonClick = () => {
    setIsLoading(true);
    const resultsSection = document.getElementById("results-section");
    resultsSection.scrollIntoView({ behavior: "smooth" });
    setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Simula una carga de 2 segundos
  };

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (window.pageYOffset > 500) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function handleScrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const data = [
      {
        id: 1,
        name: "Software POS para restaurantes en Colombia",
        description:
          "En el dinámico mundo de la gastronomía en Colombia, la gestión eficiente es fundamental para el éxito continuo de cualquier establecimiento. Un sistema de punto de venta (POS) no es simplemente una herramienta para procesar transacciones; es la columna vertebral de la operación diaria, facilitando desde la toma de pedidos hasta la gestión del inventario y la generación de informes.",
        date: "March 5, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/software-pos-para-restaurantes-en-colombia",
        imageSrc:
          "https://img.invupos.com/invu%20colombia/blog/software-pos-para-restaurantes-en-colombia.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 2,
        name: "5 Razones para tener un Software POS en tu negocio",
        description:
          "La gestión eficiente de un restaurante es clave para su éxito a largo plazo. En la era digital actual, los restaurantes pueden beneficiarse enormemente al invertir en software especializado que les ayude a optimizar sus operaciones y mejorar la experiencia del cliente. En este artículo, exploraremos cinco razones convincentes por las cuales deberías considerar invertir en un software para tu restaurante.",
        date: "March 15, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/cinco-razones-para-tener-un-software-POS-en-tu-negocio",
        imageSrc:
          "https://img.invupos.com/invu%20colombia/blog/cinco-razones-para-tener-un-software-POS-en-tu-negocio.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 3,
        name: "Estrategias para Aumentar las Ventas con un Sistema POS en tu Bar",
        description:
          "En la industria de la hospitalidad, especialmente en el sector de bares, aumentar las ventas es una prioridad constante. La implementación efectiva de un sistema POS no solo simplifica las operaciones, sino que también puede ser una herramienta poderosa para impulsar el crecimiento y la rentabilidad del negocio. En este artículo, exploraremos estrategias prácticas para aprovechar al máximo tu sistema POS y aumentar las ventas en tu bar.",
        date: "March 28, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/estrategias-para-aumentar-las-ventas-con-un-sistema-pos-en-tu-bar",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/estrategias-para-aumentar-las-ventas-con-un-sistema-pos-en-tu-bar.jpg",
        imageAlt: "",
        category: "Finances",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 4,
        name: "El Futuro del Café: Tendencias Tecnológicas que Debes Conocer en la Industria Cafetera",
        description:
          "El café, mucho más que una simple bebida, es una experiencia sensorial que ha evolucionado con el tiempo. En la era digital, la industria cafetera se encuentra en un punto de inflexión, donde la tecnología está transformando la forma en que se cultiva, se prepara y se disfruta esta popular bebida. En este artículo, exploraremos las tendencias tecnológicas que están dando forma al futuro del café y cómo la integración de un sistema POS puede potenciar estas innovaciones en las cafeterías de todo el mundo.",
        date: "April 3, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/el-futuro-del-cafe-tendencias-tecnologicas-que-debes-conocer-en-la-industria-cafetera",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/el-futuro-del-cafe-tendencias-tecnologicas-que-debes-conocer-en-la-industria-cafetera.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 5,
        name: "Del Pedido a la Mesa: Cómo los Sistemas KDS Agilizan el Flujo de Trabajo en la Cocina",
        description:
          "En la dinámica y ajetreada atmósfera de un restaurante, la eficiencia en la cocina es fundamental para ofrecer una experiencia gastronómica excepcional a los comensales. En este sentido, los sistemas KDS (Kitchen Display Systems) han surgido como una herramienta indispensable, transformando por completo la forma en que los pedidos se procesan y se llevan a cabo en la cocina. Vamos a explorar cómo estos sistemas están optimizando el flujo de trabajo en la cocina y mejorando la experiencia general del restaurante.",
        date: "April 4, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/del-pedido-a-la-mesa-como-los-sistemas-kds-agilizan-el-flujo-de-trabajo-en-la-oficina",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/del-pedido-a-la-mesa-como-los-sistemas-kds-agilizan-el-flujo-de-trabajo-en-la-oficina.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 6,
        name: "Optimizando tu Cocina con un KDS: Consejos y Trucos de un Chef",
        description:
          "En la agitada atmósfera de una cocina profesional, la coordinación y la eficiencia son fundamentales para mantener la calidad y la satisfacción del cliente. En este sentido, los sistemas de visualización de cocina (KDS, por sus siglas en inglés) han demostrado ser una herramienta invaluable para optimizar las operaciones y agilizar el servicio en restaurantes y establecimientos gastronómicos de todo tipo.",
        date: "April 8, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/optimizando-tu-cocina-con-un-kds-consejos-y-trucos-de-un-chef",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/optimizando-tu-cocina-con-un-kds-consejos-y-trucos-de-un-chef.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 7,
        name: "5 Razones por las que tu Restaurante Necesita una Página Web Moderna",
        description:
          "En la era digital actual, tener una presencia en línea sólida es fundamental para el éxito de cualquier negocio, incluidos los restaurantes. Una página web moderna no solo es una herramienta de marketing poderosa, sino que también puede ser un factor determinante en la atracción y retención de clientes.",
        date: "April 11, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/cinco-razones-por-las-que-tu-restaurante-necesita-una-pagina-web-moderna",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/cinco-razones-por-las-que-tu-restaurante-necesita-una-pagina-web-moderna.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 8,
        name: "Cómo Mejorar la Experiencia del Cliente con Tecnología en tu Bar",
        description:
          "En la industria de la hospitalidad, la experiencia del cliente es fundamental para el éxito de cualquier negocio, y los bares no son una excepción. Hoy en día, la tecnología desempeña un papel crucial en la mejora de esta experiencia, permitiendo a los bares ofrecer un servicio más eficiente, personalizado y atractivo para sus clientes.",
        date: "April 15, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-mejorar-la-experiencia-del-cliente-con-tecnologia-en-tu-bar",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/como-mejorar-la-experiencia-del-cliente-con-tecnologia-en-tu-bar.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 9,
        name: "Cómo un sistema POS puede ayudar a impulsar las ventas en el restaurante del hotel",
        description:
          "Los eventos y banquetes son oportunidades únicas para los hoteles para aumentar sus ingresos y atraer a nuevos clientes. Sin embargo, gestionar eficazmente estos eventos puede ser un desafío logístico. Aquí es donde un sistema de punto de venta (POS) puede marcar la diferencia.",
        date: "April 23, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-un-sistema-pos-puede-ayudar-a-impulsar-las-ventas-en-el-restaurante-del-hotel",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/como-un-sistema-pos-puede-ayudar-a-impulsar-las-ventas-en-el-restaurante-del-hotel.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 10,
        name: "Descubre donde comprar los Mejores Utensilios para un Chef",
        description:
          "Cuando se trata de equipar una cocina profesional o doméstica, la calidad de los utensilios es fundamental. Le Creuset, una marca reconocida por su excelencia en utensilios de cocina, ofrece una amplia gama de productos que son imprescindibles para cualquier chef. Desde sartenes y ollas hasta herramientas especializadas, los productos de Le Creuset combinan estilo, durabilidad y funcionalidad para satisfacer las necesidades de los chefs más exigentes.",
        date: "April 26, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/descubre-donde-comprar-los-mejores-utensilios-para-un-chef",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/descubre-donde-comprar-los-mejores-utensilios-para-un-chef.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 11,
        name: "La Importancia de un Sistema POS en los Festivales: Optimizando la Experiencia del Cliente y la Gestión del Evento",
        description:
          "Los festivales son eventos vibrantes y dinámicos que atraen a multitudes ávidas de música, arte, comida y entretenimiento. Sin embargo, detrás de la diversión y el bullicio, existe una logística compleja que requiere una gestión eficiente para garantizar el éxito del festival. En este contexto, la implementación de un sistema de punto de venta (POS, por sus siglas en inglés) desempeña un papel crucial en la optimización de la experiencia del cliente y la gestión del evento. A continuación, exploramos la importancia de un sistema POS en los festivales:",
        date: "May 7, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/la-importancia-de-un-sistema-pos-en-los-festivales-optimizando-la-experiencia-del-cliente-y-la-gestion-del-evento",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/la-importancia-de-un-sistema-pos-en-los-festivales.jpeg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 12,
        name: "Los Beneficios del Delivery Online",
        description:
          "En el cambiante panorama de la industria alimentaria, adaptarse a las nuevas tendencias es fundamental para el éxito de un restaurante. En este artículo, exploraremos cómo el delivery online se ha convertido en una herramienta indispensable para los propietarios de restaurantes y cómo la integración con INVU POS puede potenciar aún más la eficiencia y el rendimiento de tu negocio.",
        date: "May 15, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/los-beneficios-del-delivery-online",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/los-beneficios-del-delivery-online.webp",
        imageAlt: "",
        category: "Delivery",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 13,
        name: "Cómo un sistema pos y control de inventario efectivos pueden hacer la diferencia",
        description:
          "Reducir las pérdidas y desperdicios es fundamental para la rentabilidad y sostenibilidad de cualquier negocio, especialmente en la industria de servicios alimentarios. En esta guía, exploraremos cómo un sistema POS y un control de inventario efectivos pueden ayudar a los propietarios de restaurantes a minimizar las pérdidas y maximizar las ganancias.",
        date: "May 29, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-un-sistema-pos-y-control-de-inventario-efectivos-pueden-hacer-la-diferencia",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/como-un-sistema-pos-y-control-de-inventario-efectivos-pueden-hacer-la-diferencia.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 14,
        name: "Guía completa para elegir el mejor sistema POS para tu cafetería",
        description:
          "¿Estás listo para transformar tu cafetería con la tecnología adecuada? Elegir el sistema POS (Punto de Venta) perfecto puede ser el cambio que necesitas para llevar tu negocio al siguiente nivel. Con tantas opciones en el mercado, encontrar la mejor puede parecer un desafío. No te preocupes, estamos aquí para ayudarte. ",
        date: "June 7, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/guia-completa-por-elegir-el-mejor-sistema-pos-para-tu-cafeteria",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/guia-completa-por-elegir-el-mejor-sistema-pos-para-tu-cafeteria.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Guides",
        country: "Colombia", 
      },
      {
        id: 15,
        name: "Marketing digital para barberías: Estrategias para atraer y retener clientes",
        description:
          "En la era digital actual, el marketing para barberías ha evolucionado más allá de los métodos tradicionales. Para atraer y retener clientes, es crucial aprovechar las herramientas digitales y las estrategias de marketing modernas. En este artículo, exploraremos diversas estrategias de marketing digital para barberías y destacaremos cómo INVU POS, con su funcionalidad de comercio electrónico y su POS especializado, puede ayudarte a alcanzar tus objetivos de negocio.",
        date: "June 13, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/marketing-digital-para-barberias-estrategias-para-atraer-y-retener-clientes",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/marketing-digital-para-barberias-estrategias-para-atraer-y-retener-clientes.jpeg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 16,
        name: "Cómo elegir el mejor sistema POS para tu estudio de tatuajes: Una guía completa",
        description:
          "Dirigir un estudio de tatuajes es una combinación única de arte, creatividad y gestión empresarial. En el corazón de esta operación se encuentra un sistema POS (Punto de Venta) eficiente y especializado. ¿Pero cómo elegir el mejor sistema POS para tu estudio de tatuajes? En esta guía exhaustiva, exploraremos los aspectos clave que debes considerar, junto con la funcionalidad y los beneficios que ofrece INVU POS para estudios de tatuajes.",
        date: "June 17, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-elegir-el-mejor-sistema-pos-para-tu-estudio-de-tatuajes-una-guia-completa",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/como-elegir-el-mejor-sistema-pos-para-tu-estudio-de-tatuajes-una-guia-completa.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 17,
        name: "INVU POS anuncia nueva integración con HERO para mejorar la contabilidad y gestión financiera de sus clientes.",
        description:
          "Ciudad de Panamá,– Invu POS, líder en soluciones de punto de venta, se complace en anunciar su reciente integración con Hero, una innovadora plataforma de contabilidad y gestión financiera. Esta colaboración tiene como objetivo simplificar y automatizar los procesos contables para los usuarios de Invu POS, proporcionando una solución integral que conecta directamente las ventas con la contabilidad.",
        date: "June 27, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/invupos-anuncia-nueva-integracion-con-hero-para-mejorar-la-contabilidad-y-gestion-financiera-de-sus-clientes",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/hero-integrations.webp",
        imageAlt: "",
        category: "Press release",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 18,
        name: "El mejor sistema POS para Spas y salones de belleza",
        description:
          "La gestión de inventarios es un aspecto crítico para el éxito de cualquier spa. Mantener un equilibrio adecuado entre la oferta y la demanda de productos de belleza puede ser un desafío constante. Un sistema POS (Point of Sale) especializado puede ser la solución ideal para optimizar este proceso, asegurando que los productos necesarios estén siempre disponibles sin exceder en inventario. ",
        date: "July 5, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/el-mejor-sistema-pos-para-spas-y-salones-de-belleza",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/el-mejor-sistema-pos-para-spas-y-salones-de-belleza.jpeg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 19,
        name: "Cómo Elegir el Mejor Sistema POS para tu Cervecería Artesanal",
        description:
          "Elegir el sistema de punto de venta (POS) adecuado es fundamental para cualquier cervecería artesanal que busque optimizar sus operaciones, mejorar la experiencia del cliente y maximizar sus ingresos. Un buen sistema POS no solo gestiona las ventas, sino que también integra múltiples aspectos del negocio, desde la gestión de inventarios hasta la fidelización del cliente. ",
        date: "July 24, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-elegir-el-mejor-sistema-pos-para-tu-cerveceria-artesanal",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/como-elegir-el-mejor-sistema-pos-para-tu-cerveceria-artesanal.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 20,
        name: "Cómo los Gift Cards Pueden Impulsar las Ventas en tu Salón de Belleza",
        description:
          "Los gift cards son una herramienta poderosa que puede transformar la manera en que operas tu salón de belleza. No solo son una excelente manera de aumentar las ventas, sino que también pueden atraer nuevos clientes y fidelizar a los existentes. En este artículo, exploraremos cómo implementar un sistema de gift card puede beneficiar a tu salón y por qué INVU POS es la solución perfecta para gestionar este proceso de manera eficiente y efectiva.",
        date: "August 2, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-los-gift-cards-pueden-impulsar-las-ventas-en-tu-salon-de-belleza",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/como-los-gift-cards-pueden-impulsar-las-ventas-en-tu-salon-de-belleza.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 21,
        name: "Simplifica tu Food Truck con un sistema de punto de venta Todo-en-Uno",
        description:
          "En el competitivo mundo de los food trucks, la eficiencia es clave para mantener el éxito y seguir creciendo. Un sistema POS todo-en-uno puede ser la solución perfecta para simplificar las operaciones diarias, mejorar la experiencia del cliente y aumentar las ventas. ¿Pero cómo funciona exactamente y qué beneficios puede traer a tu negocio? Vamos a profundizar en ello.",
        date: "August 27, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/simplifica-tu-food-truck-con-un-sistema-de-punto-de-venta-todo-en-uno",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/simplifica-tu-food-truck-con-un-sistema-de-punto-de-venta-todo-en-uno.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 22,
        name: "Anunciamos nuestra participación en ABASTUR México 2024",
        description:
          "Estamos emocionados de anunciar que participaremos en ABASTUR México 2024, el evento más grande y relevante para la industria de la hospitalidad en América Latina. Este año marca un hito importante para nosotros, ya que no solo estaremos presentes en la feria, sino que también celebramos nuestra llegada oficial al mercado mexicano. En Invu POS, nuestro objetivo ha sido siempre transformar la manera en que los restaurantes y negocios de hospitalidad operan, ayudándoles a ser más eficientes y a brindar experiencias excepcionales a sus clientes.",
        date: "August 28, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/anunciamos-nuestra-participacion-en-abastur-mexico-2024",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/anunciamos-nuestra-participacion-en-abastur-mexico-2024.jpg",
        imageAlt: "",
        category: "Press release",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 23,
        name: "Las wallets Digitales y sus beneficios para tu restaurante",
        description:
          "En un mundo cada vez más digital, los métodos de pago han evolucionado para adaptarse a las nuevas tecnologías. Las wallets digitales, también conocidas como billeteras electrónicas, se han vuelto cada vez más populares entre los consumidores, especialmente en la industria de la restauración. Estas soluciones de pago ofrecen una forma rápida, segura y conveniente de realizar transacciones, lo que representa una gran oportunidad para los restaurantes que desean mejorar la experiencia del cliente y optimizar sus operaciones. En este artículo, exploraremos qué son las wallets digitales y cuáles son sus beneficios para tu restaurante.",
        date: "September 30, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/las-wallets-digitales-y-sus-beneficios-para-tu-restaurante",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/las-wallets-digitales-y-sus-beneficios-para-tu-restaurante.jpg",
        imageAlt: "",
        category: "Finances",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 24,
        name: "La digitalización del comercio en colombia: el rol del software pos",
        description:
          "En los últimos años, la digitalización del comercio ha transformado la manera en la que las empresas operan en Colombia. Desde pequeñas tiendas locales hasta grandes cadenas de restaurantes, los negocios están adoptando soluciones tecnológicas para optimizar sus operaciones, mejorar la experiencia del cliente y mantenerse competitivos en un mercado cada vez más digital. Uno de los elementos clave en esta transición ha sido la implementación de sistemas de punto de venta (POS), que permiten a los comercios y restaurantes gestionar de manera eficiente todas sus operaciones, desde la venta hasta el control de inventarios. En este artículo, exploraremos la importancia de los sistemas POS en la digitalización del comercio en Colombia y cómo Invu POS se presenta como una solución ideal para el sector.",
        date: "October 16, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/la-digitalizacion-del-comercio-en-colombia-el-rol-del-software-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/la-digitalizacion-del-comercio-en-colombia-el-rol-del-software-pos.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 25,
        name: "Mejora la gestión de tu restaurante en Colombia",
        description:
          "El sector restaurantero en Colombia es uno de los más dinámicos y competitivos en América Latina. Con la creciente demanda de servicios de alta calidad y una clientela cada vez más exigente, los dueños y gerentes de restaurantes deben buscar maneras innovadoras para optimizar sus operaciones. Una de las soluciones más eficaces es el uso de sistemas de punto de venta (POS) en la nube, que no solo mejoran la gestión operativa, sino que también impulsan el crecimiento de los negocios.",
        date: "November 7, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/mejora-la-gestion-de-tu-restaurante-en-colombia",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/mejora-la-gestion-de-tu-restaurante-en-colombia.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 26,
        name: "7 Formas de impulsar los ingresos de un hotel",
        description:
          "En la industria hotelera, maximizar los ingresos y brindar una experiencia excepcional a los huéspedes son prioridades. Lograrlo requiere herramientas tecnológicas que optimicen procesos y mejoren la eficiencia. La integración entre Invu POS y Cloudbeds ofrece a los hoteles una solución completa para transformar sus operaciones diarias y aumentar su rentabilidad.",
        date: "November 26, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/siete-formas-de-impulsar-los-ingresos-de-un-hotel",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/siete-formas-de-impulsar-los-ingresos-de-un-hotel.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 27,
        name: "Aumentar ingresos con las integraciones de delivery de INVU POS",
        description:
          "El mercado de delivery sigue creciendo exponencialmente, convirtiéndose en una de las principales fuentes de ingresos para los restaurantes. Sin embargo, este crecimiento también presenta retos: altas comisiones de las plataformas, errores en los pedidos y tiempos de entrega que pueden impactar la experiencia del cliente. Aquí es donde las integraciones de delivery con Invu POS marcan la diferencia, no solo resolviendo estos problemas, sino también ayudándote a maximizar tus márgenes y aumentar tus ingresos.",
        date: "November 26, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/aumentar-ingresos-con-las-integraciones-de-delivery-de-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/aumentar-ingresos-con-las-integraciones-de-delivery-de-invu-pos.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 28,
        name: "La Revolución Digital para Restaurantes en Colombia",
        description:
          "La industria gastronómica en Colombia está en constante evolución, impulsada por un consumidor más exigente y un mercado cada vez más competitivo. En este contexto, Invu POS se posiciona como un aliado estratégico para los restaurantes que buscan optimizar su operación, mejorar la experiencia del cliente y aumentar su rentabilidad. Desde integraciones de delivery y sistemas de reservas de mesas, hasta programas de fidelización y sistemas KDS (Kitchen Display Systems), las soluciones de Invu POS están marcando la diferencia en el panorama gastronómico colombiano.",
        date: "December 5, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/la-revolucion-digital-para-restaurantes-en-colombia",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/la-revolucion-digital-para-restaurantes-en-colombia-2.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 29,
        name: "La Clave para un Fin de Año Exitoso",
        description:
          "La temporada navideña es una de las épocas más dinámicas para los restaurantes. Desde cenas familiares hasta celebraciones de empresas y encuentros con amigos, los establecimientos se enfrentan a un incremento significativo en el flujo de clientes.  Este aumento, aunque bienvenido, puede convertirse en un desafío si no se cuenta con las herramientas adecuadas para gestionarlo. Es aquí donde un sistema POS moderno y eficiente se convierte en un aliado esencial para garantizar un servicio ágil, organizado y memorable.",
        date: "December 10, 2024",
        views: "2.3k",
        comments: "27",
        href: "/blog/la-clave-para-un-fin-de-año-exitoso",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/la-clave-para-un-fin-de-a%C3%B1o-exitoso.jpeg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 30,
        name: "Invu POS, el software elegido por iMin para el NRF 2025",
        description:
          "Ciudad de Panamá, Viernes 10 de Enero del 2025 – INVU POS se enorgullece de anunciar su participación en el evento más importante de la industria del retail, el National Retail Federation (NRF) Retail’s Big Show 2025, que se llevará a cabo en Nueva York del 14 al 16 de enero.",
        date: "January 10, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/invu-pos-el-software-elegido-por-imin-para-el-nrf-2025",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/invu-pos-el-software-elegido-por-imin-para-el-nrf-2025.jpg",
        imageAlt: "",
        category: "Press release",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 31,
        name: "La Importancia de un Sistema POS para el Control de Comandas en un Restaurante",
        description:
          "En la industria gastronómica, la eficiencia y la precisión son clave para ofrecer una excelente experiencia al cliente. Uno de los mayores retos que enfrentan los restaurantes es el manejo adecuado de las comandas: esos pedidos que pasan de las mesas a la cocina y luego vuelven como deliciosos platos listos para servir. En este escenario, contar con un sistema POS (Point of Sale o Punto de Venta) se ha vuelto indispensable. Veamos en profundidad los beneficios que puede aportar.",
        date: "February 04, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/la-importancia-de-un-sistema-pos-para-el-control-de-comandas-en-un-restaurante",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/la-importancia-de-un-sistema-pos-para-el-control-de-comandas-en-un-restaurante.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 32,
        name: "La Evolución de los sistemas POS en Colombia: de la caja registradora al software inteligente",
        description:
          "El sector comercial en Colombia ha experimentado una transformación significativa en las últimas décadas. Desde las tradicionales cajas registradoras mecánicas hasta los modernos sistemas de punto de venta (POS) que integran tecnología de vanguardia, el comercio se ha adaptado a las demandas de una economía cada vez más digital y competitiva. Esta evolución ha mejorado no solo la eficiencia operativa de los negocios, sino también la experiencia del cliente.",
        date: "February 11, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/la-evolucion-de-los-sistemas-pos-en-colombia-de-la-caja-registradora-al-software-inteligente",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/la-evolucion-de-los-sistemas-pos-en-colombia-de-la-caja-registradora-al-software-inteligente.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 33,
        name: "Optimiza Tu Food Truck en Colombia: Eficiencia en la Toma de Pedidos, Agilización de Procesos y Control de Inventarios",
        description:
          "Los food trucks en Colombia se han convertido en una de las opciones más populares para los amantes de la comida rápida y deliciosa. Sin embargo, a medida que crece la demanda, también lo hacen los desafíos que enfrentan los dueños de estos negocios móviles. El espacio reducido, la alta rotación de clientes y la necesidad de ofrecer un servicio rápido y preciso son solo algunos de los retos.",
        date: "March 10, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/optimiza-tu-food-truck-en-colombia",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/optimiza-tu-food-truck-en-colombia.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 34,
        name: "5 formas en las que un POS en la nube mejora la experiencia del cliente",
        description:
          "Cuando se trata de ofrecer una experiencia excepcional a tus clientes, cada detalle cuenta. Un sistema POS en la nube no solo optimiza la operación de tu negocio, sino que también impacta directamente en la satisfacción del cliente.",
        date: "March 12, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/cinco-formas-en-las-que-un-pos-en-la-nube-mejora-la-experiencia-del-cliente",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/cinco-formas-en-las-que-un-pos-en-la-nube-mejora-la-experiencia-del-cliente.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 35,
        name: "KDS Incorporado con POS: La Clave para una Cocina Eficiente",
        description:
          "En la industria gastronómica, la rapidez y organización en la cocina son esenciales para ofrecer una excelente experiencia al cliente. Un KDS (Kitchen Display System) integrado con un sistema POS optimiza el flujo de trabajo en la cocina, eliminando el uso de comandas en papel y reduciendo errores en los pedidos.",
        date: "March 25, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/kds-incorporado-con-pos-la-clave-para-una-cocina-eficiente",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/kds-incorporado-con-pos-la-clave-para-una-cocina-eficiente.jpeg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 36,
        name: "Beneficios de un Sistema POS para la Gestión de Inventarios en Retail en Colombia",
        description:
          "La gestión de inventarios es un aspecto crítico para cualquier comercio retail en Colombia. Un manejo ineficiente puede generar pérdidas por sobrestock, desabastecimiento o errores en los registros. Implementar un sistema POS para retailoptimiza el control del inventario, automatiza procesos y mejora la rentabilidad del negocio. En este artículo, exploramos los principales beneficios de un POS para la gestión de inventarios en Colombia y por qué es clave para el crecimiento de tu tienda.",
        date: "April 03, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/beneficios-de-un-sistema-pos-para-la-gestion-de-inventarios-en-retail-en-colombia",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/benefits_of_a_POS_system_for_retail_inventory_management_in_colombia.jpeg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 37,
        name: "Más propinas, menos problemas: ¿Por qué tu restaurante en Colombia necesita un POS con división de cuentas?",
        description:
          "En ciudades como Medellín, Bogotá, Cali o Cartagena, salir con amigos a comer es una de las actividades favoritas para celebrar cumpleaños, ponerse al día, ver el partido o simplemente disfrutar de buena comida. Pero hay algo que siempre pasa al final de la noche: dividamos la cuenta.",
        date: "April 21, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/mas-propinas-menos-problemas-por-que-tu-restaurante-en-colombia-necesita-un-pos-con-division-de-cuentas",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/mas-propinas-menos-problemas-por-que-tu-restaurante-en-colombia-necesita-un-pos-con-division-de-cuentas.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 38,
        name: "Descubre las nuevas Novedades de Invu POS",
        description:
          "¡Invu POS 3 sigue evolucionando! En esta nueva versión incorporamos integraciones con ADYEN y BOLD, mejoras clave en la apertura de caja, facturación electrónica y reportes, incluyendo el nuevo Reporte de Cierre del Día y el reporte de tasa de cambio. Ahora puedes eliminar clientes de una orden, confirmar número de invitados desde el iPad, y aprovechar herramientas como el importador masivo de imágenes y mejoras en administración multi-sucursal. También optimizamos la visualización de productos en negocios retail, la edición de descripciones y la lógica de ítems bloqueados. Todo pensado para que tu operación sea más ágil, precisa y conectada. ¡Actualízate y lleva tu punto de venta al siguiente nivel!",
        date: "May 12, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/descubre-las-nuevas-novedades-de-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/Novedades-invu-pos.png",
        imageAlt: "",
        category: "Press release",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 39,
        name: "Lealtad en la era digital: ¿Cómo los restaurantes en Colombia están creando conexiones duraderas con sus clientes?",
        description:
          "En un mercado cada vez más competitivo como el gastronómico colombiano, captar la atención del cliente ya no es suficiente. La verdadera clave del crecimiento está en retener a quienes ya te conocen, en convertir visitas esporádicas en relaciones duraderas. Y para eso, necesitas algo más que buena comida: necesitas una estrategia de lealtad bien diseñada y apoyada por tecnología.",
        date: "May 21, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/lealtad-en-la-era-digital-como-los-restaurantes-en-colombia-estan-creando-conexiones-duraderas-con-sus-clientes",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/lealtad-en-la-era-digital-como-los-restaurantes-en-colombia-estan-creando-conexiones-duraderas-con-sus-clientes.jpeg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 40,
        name: "Errores comunes en la gestión de cafeterías (y cómo evitarlos con Invu POS)",
        description:
          "Abrir una cafetería en Colombia puede parecer un sueño romántico: el aroma del café recién molido, un espacio acogedor, clientes satisfechos... Pero detrás de la barra, la realidad operativa puede ser mucho más compleja. Desde el manejo del inventario hasta la experiencia del cliente, hay muchos detalles que pueden marcar la diferencia entre una cafetería exitosa y una que lucha por mantenerse a flote.",
        date: "June 24, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/errores-comunes-en-la-gestion-de-cafeterias-y-como-evitarlos-con-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/errores-comunes-en-la-gestion-de-cafeterias-y-como-evitarlos-con-invu-pos.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 41,
        name: "¿Por qué tu cocina en Colombia necesita un KDS moderno? Más velocidad, menos errores y mejor servicio",
        description:
          "En el competitivo mundo de la gastronomía en Colombia, ofrecer una excelente experiencia al cliente ya no depende solo de una buena receta. La rapidez, precisión y coordinación en cocina son claves para el éxito. Y ahí es donde entra el KDS (Kitchen Display System) o sistema de pantallas de cocina. Si todavía usas comandas en papel o los meseros gritan las órdenes, estás perdiendo eficiencia y arriesgándote a cometer errores costosos. Un KDS moderno, integrado a tu sistema POS, puede transformar por completo la forma en que trabajas, desde la cocina hasta la atención al cliente.",
        date: "July 14, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/por-que-tu-cocina-en-colombia-necesita-un-kds-moderno-mas-velocidad-menos-errores-y-mejor-servicio",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/Por%20qu%C3%A9%20tu%20cocina%20en%20Colombia%20necesita%20un%20KDS.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 42,
        name: "¿Eres dueño o gerente de hotel? Esta integración entre Invu POS y Cloudbeds puede transformar tu operación",
        description:
          "Administrar un hotel es mucho más que ofrecer habitaciones cómodas. Es coordinar múltiples áreas operativas, asegurar una experiencia impecable para los huéspedes y, al mismo tiempo, mantener la rentabilidad del negocio. Y si en tu día a día trabajas con sistemas aislados —uno para las reservas, otro para el restaurante, otro para la facturación—, sabes lo complejo que puede ser mantener todo en orden.",
        date: "July 24, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/eres-dueño-o-gerente-de-hotel-esta-integracion-entre-invupos-y-cloudbeds-puede-transformar-tu-operacion",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/eres-due%C3%B1o-o-gerente-de-hotel-esta-integracion-entre-invupos-y-cloudbeds-puede-transformar-tu-operacion_uw17s3.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 43,
        name: "5 Estrategias para Aumentar Ventas Usando Programas de Lealtad Digital en Colombia",
        description:
          "En el mercado colombiano, donde la competencia entre restaurantes, cafeterías y comercios está más fuerte que nunca, la fidelización de clientes se ha convertido en una de las estrategias más rentables. Un programa de lealtad digital bien implementado no solo premia las compras, sino que también impulsa el consumo frecuente y fortalece la relación con los clientes.",
        date: "August 12, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/cinco-estrategias-para-aumentar-ventas-usando-programas-de-lealtad-digital-en-colombia",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/cinco-estrategias-para-aumentar-ventas-usando-programas-de-lealtad-digital-en-colombia_warkv9.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 44,
        name: "5 formas en que la facturación digital con Invu POS mantiene tu negocio en orden",
        description:
          "En América Latina, los negocios se enfrentan a una realidad común: llevar el control de las ventas, el inventario y la facturación al mismo tiempo. Desde un pequeño café en Ciudad de México, hasta una cadena de restaurantes en Bogotá o un supermercado en Santo Domingo, todos comparten un reto: mantener el orden administrativo y cumplir con las regulaciones fiscales sin perder productividad.",
        date: "September 15, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/cinco-formas-en-que-la-facturacion-digital-con-invu-pos-mantiene-tu-negocio-en-orden",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/mantiene-tu-negocio-en-orden.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 45,
        name: "Delivery en Colombia: cómo los restaurantes pueden gestionarlo de forma más eficiente con Invu POS",
        description:
          "El mercado gastronómico en Colombia está en pleno auge y el delivery se ha convertido en el corazón del crecimiento de muchos restaurantes. Hoy, pedir comida desde una aplicación o página web es parte de la rutina de miles de colombianos. En ciudades como Bogotá, Medellín, Cali o Barranquilla, los consumidores esperan rapidez, precisión y una experiencia impecable al pedir sus platos favoritos.",
        date: "September 19, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/delivery-en-colombia-como-los-restaurantes-pueden-gestionarlo-de-forma-mas-eficiente-con-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-cottonbro-4604599_bufpbv.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 46,
        name: "Cómo transformar tu restaurante en un ecommerce rentable con Invu POS",
        description:
          "El mundo de la gastronomía ha cambiado. Ya no se trata solo de tener un buen menú o una excelente atención al cliente, sino de estar presente donde tus clientes están: en línea. Hoy, los restaurantes que combinan su operación física con un ecommerce eficiente no solo venden más, sino que también crean experiencias más completas, modernas y convenientes.",
        date: "October 6, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-transformar-tu-restaurante-en-un-ecommerce-rentable-con-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-olly-831012_yn3hvg.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 47,
        name: "10 formas en que un buen sistema POS transforma la eficiencia de tu restaurante",
        description:
          "Si hay algo que todos los dueños de restaurantes sabemos, es que un servicio rápido, preciso y amable puede marcar la diferencia entre un cliente que vuelve… y uno que no. Pero lo que a veces no se ve tan claro es cuánto influye la tecnología en ese resultado. Un equipo puede ser excelente, pero si no tiene las herramientas correctas, se desgasta, se frustra y pierde tiempo en tareas que podrían automatizarse.",
        date: "October 13, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/diez-formas-en-que-un-buen-sistema-pos-transforma-la-eficiencia-de-tu-restaurante",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-lexi-lauwers-1431940-33867784.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 48,
        name: "¿Qué tan rentable es tu restaurante? Descubre los números que realmente importan",
        description:
          "Ser dueño de un restaurante en Colombia es un desafío apasionante. La competencia crece todos los días, los costos cambian constantemente y los clientes son cada vez más exigentes. Pero detrás de cada mesa servida, hay un factor que define si tu negocio realmente es rentable: el control de los números.",
        date: "October 20, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/que-tan-rentable-es-tu-restaurante-descubre-los-numeros-que-realmente-importan",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-zona-exe123ph-2148683684-34104246.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 49,
        name: "El caos de fin de año en los restaurantes: cómo mantener el control con Invu POS",
        description:
          "Noviembre y diciembre son meses intensos para los restaurantes. Las reservas aumentan, los pedidos se multiplican y el flujo de clientes se dispara. Todo esto es una gran oportunidad de ventas, pero también puede convertirse en una pesadilla para quienes no tienen el control total de su operación. En medio de ese caos, los errores se vuelven más frecuentes: inventarios que no cuadran, tiempos de espera más largos, pedidos que se pierden, facturación atrasada y personal que simplemente no da abasto.",
        date: "November 11, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/el-caos-de-fin-de-ano-en-los-restaurantes-como-mantener-el-control-con-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-picjumbo-com-55570-196648.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 50,
        name: "El caos en la cocina no es una opción: por qué un buen KDS puede cambiar tu cierre de año",
        description:
          "Diciembre no perdona. Las mesas llenas, los pedidos en fila, el personal corriendo entre la barra y la cocina, los tickets amontonados sobre la plancha. Es la temporada más intensa del año para cualquier restaurante, y también la que más pone a prueba la organización, la eficiencia y la tecnología detrás de cada operación.",
        date: "November 13, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/el-caos-en-la-cocina-no-es-una-opcion-por-que-un-buen-kds-puede-cambiar-tu-cierre-de-ano",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-adrien-olichon-1257089-2537605.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 51,
        name: "Cómo el Programa de Lealtad de Invu POS Impulsa tus Ventas en Navidad",
        description:
          "La temporada navideña es, sin duda, el momento más competitivo y emocionante del año para los comercios. Más clientes, más compras impulsivas, más promociones… pero también más opciones para elegir. En este ambiente tan movido, diferenciarte no solo depende de tener buenos productos o un excelente servicio. Hoy, la verdadera clave está en crear experiencias memorables que hagan que las personas vuelvan una y otra vez.",
        date: "November 17, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-el-programa-de-lealtad-de-invu-pos-impulsa-tus-ventas-en-navidad",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-nicole-michalou-5764899.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 52,
        name: "Convierte la época más movida del año en oportunidad con el programa de lealtad de Invu Pos",
        description:
          "En Colombia, diciembre no es solo un mes: es una temporada completa de movimiento, tradición y consumo. Entre las novenas, los intercambios, las cenas familiares, las fiestas empresariales y el famoso aguinaldo, los comercios viven uno de los cierres de año más intensos de toda la región.",
        date: "November 24, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/convierte-la-epoca-mas-movida-del-ano-en-oportunidad-con-el-programa-de-lealtad-de-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-pixabay-264771.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 53,
        name: "Regalos que generan ingresos: cómo vender giftcards digitales con Invu POS esta Navidad",
        description:
          "La temporada navideña no solo es el momento más fuerte del año para las ventas: también es la oportunidad perfecta para que los comercios aumenten su alcance, conecten con nuevos clientes y generen ingresos incluso antes de que entren por la puerta. Y entre todas las estrategias posibles, hay una que destaca por ser simple, efectiva y altamente rentable: las giftcards digitales.",
        date: "December 03, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/regalos-que-generan-ingresos-como-vender-giftcards-digitales-con-invu-pos-esta-navidad",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-matteo-sassola-2156165555-35004242.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 54,
        name: "Cierre de Año, Ventas al Máximo: Cómo un POS Inteligente Impulsa tu Temporada de Diciembre",
        description:
          "Diciembre es ese mes donde todo se acelera: más clientes, más pedidos, más movimientos, más oportunidades… y también más retos. Para un restaurante, cafetería o comercio retail, diciembre puede ser el mes más rentable del año… o el más caótico, si no se cuenta con las herramientas adecuadas.",
        date: "December 04, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/cierre-de-ano-ventas-al-maximo-como-un-pos-inteligente-impulsa-tu-temporada-de-diciembre",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-chanwalrus-941861.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 55,
        name: "Cómo preparar tu delivery para la temporada más movida del año",
        description:
          "En Navidad, los restaurantes enfrentan uno de los momentos más intensos del año: los pedidos aumentan, las expectativas del cliente suben y la operación necesita ser más eficiente que nunca. Aunque esta temporada representa una gran oportunidad para aumentar ventas, también puede volverse caótica si el negocio no está preparado.",
        date: "December 09, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-preparar-tu-delivery-para-la-temporada-mas-movida-del-ano",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-cottonbro-4114066.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 56,
        name: "Control de mesas y KDS: cuando diciembre pone a prueba tu restaurante",
        description:
          "En Navidad, los restaurantes enfrentan uno de los momentos más intensos del año: los pedidos aumentan, las expectativas del cliente suben y la operación necesita ser más eficiente que nunca. Aunque esta temporada representa una gran oportunidad para aumentar ventas, también puede volverse caótica si el negocio no está preparado.",
        date: "December 17, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/control-de-mesas-y-kds-cuando-diciembre-pone-a-prueba-tu-restaurante",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-anhelina-vasylyk-734724285-35001452.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 57,
        name: "Cuentas separadas, mesas felices: el secreto para sobrevivir a la temporada navideña",
        description:
          "La temporada navideña tiene algo especial. Las mesas se llenan, los brindis se multiplican y los restaurantes se convierten en el punto de encuentro de amigos, familias y compañeros de trabajo. Pero también es la época donde la operación se pone a prueba. Grupos grandes, pedidos variados y, al final de la noche, la gran pregunta: ¿cómo dividimos la cuenta?",
        date: "December 23, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/cuentas-separadas-mesas-felices-el-secreto-para-sobrevivir-a-la-temporada-navidena",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-nicole-michalou-5775048.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 58,
        name: "Enero: el mes perfecto para ordenar tu negocio y vender mejor con un POS moderno",
        description:
          "Enero marca el verdadero inicio del año para los negocios en México, Colombia y Panamá. Después de un diciembre intenso, llega el momento clave para analizar resultados, ordenar procesos y tomar decisiones que impactarán las ventas durante todo el año. Aquí es donde un sistema POS moderno deja de ser un gasto y se convierte en una herramienta estratégica.",
        date: "January 6, 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/enero-el-mes-perfecto-para-ordenar-tu-negocio-y-vender-mejor-con-un-pos-moderno",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-chevanon-323503.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 59,
        name: "Tendencias tecnológicas para restaurantes y comercios en Latinoamérica en 2026",
        description:
          "Por qué Invu POS es el mejor sistema POS para crecer en la región El sector de restaurantes y comercios en Latinoamérica está atravesando una transformación acelerada. Los hábitos de consumo evolucionaron, los clientes son más digitales y la tecnología dejó de ser un lujo para convertirse en una herramienta clave de competitividad.",
        date: "January 12, 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/tendencias-tecnologicas-restaurantes-comercios-latinoamerica-2026",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-nick-gorniok-495871763-35550991.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 60,
        name: "Las integraciones que todo restaurante en Colombia necesita en su sistema POS para ser realmente rentable",
        description:
          "El sector gastronómico en Colombia está creciendo. Bogotá, Medellín, Cali, Barranquilla y muchas otras ciudades están viviendo una nueva ola de restaurantes, cafés y conceptos innovadores. Pero con ese crecimiento también llegó algo más: competencia intensa.",
        date: "February 11, 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/las-integraciones-que-todo-restaurante-en-colombia-necesita-en-su-sistema-pos-para-ser-realmente-rentable",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-fotios-photos-1833399.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 61,
        name: "Cómo aumentar la frecuencia de clientes en tu restaurante sin invertir más en publicidad: el poder del Punch Card digital", 
        description:
          "Estrategias de fidelización que realmente generan ventas recurrentes En la industria gastronómica y retail, uno de los mayores errores es medir el crecimiento únicamente por la cantidad de nuevos clientes. La realidad es otra: los negocios más rentables no son los que más clientes atraen, sino los que logran que sus clientes regresen constantemente.",
        date: "March 19 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-aumentar-frecuencia-clientes-restaurante-sin-invertir-publicidad-punch-card-digital",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/73796c3b-9f88-40a9-a31c-49e9d32d83c3.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 62,
        name: "Facturación electrónica en Colombia: cómo un sistema POS puede simplificar tu negocio en 2026", 
        description:
          "En Colombia, la facturación electrónica ya no es una opción, es una obligación para la mayoría de los negocios. Desde restaurantes hasta tiendas retail, cumplir con los requisitos de la DIAN se ha convertido en un aspecto clave para operar legalmente y evitar sanciones. Sin embargo, muchos negocios aún ven este proceso como algo complejo, técnico y difícil de implementar.",
        date: "April 16, 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/facturacion-electronica-en-colombia-como-un-sistema-pos-puede-simplificar-tu-negocio-en-2026",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-cmrcn-30243609.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 63,
        name: "Cómo un sistema POS puede transformar una cafetería en Colombia: beneficios de implementar INVU POS", 
        description:
          "La industria de las cafeterías en Colombia está viviendo uno de sus momentos más competitivos y dinámicos. El crecimiento de las cafeterías de especialidad, el aumento de los pedidos digitales y la necesidad de ofrecer experiencias rápidas y personalizadas han llevado a muchos negocios a modernizar su operación con tecnología especializada.",
        date: "May 11 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-un-sistema-pos-puede-transformar-una-cafeteria-en-colombia-beneficios-de-implementar-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/800a4608-b0a6-41d1-b53b-5948810786b3.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 64,
        name: "El secreto de los restaurantes que más crecen en Colombia: fidelizar clientes", 
        description:
          "La industria gastronómica en Colombia está viviendo una transformación sin precedentes. La apertura constante de nuevos restaurantes, cafeterías, cadenas de comida rápida y negocios especializados ha elevado la competencia a niveles históricos. En ciudades como Bogotá, Medellín, Cali y Barranquilla, los consumidores tienen más opciones que nunca para elegir dónde comer, pedir a domicilio o disfrutar un café.",
        date: "June 09 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/el-secreto-de-los-restaurantes-que-mas-crecen-en-colombia-fidelizar-clientes",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/addd48ca-f536-4b8f-aa91-c92d45aad749.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 65,
        name: "¿Cuánto le cuesta a un restaurante colombiano no tener control de su inventario?", 
        description:
          "En un restaurante, vender más no siempre significa ganar más. Un negocio puede tener una gran cantidad de pedidos todos los días y aun así perder dinero por ingredientes desperdiciados, compras excesivas, productos vencidos, errores en las porciones o diferencias entre el inventario registrado y el inventario real. Por eso, tener un buen control de inventario para restaurantes es fundamental para conocer cuánto compras, cuánto utilizas, cuánto desperdicias y cuánto realmente te cuesta preparar cada plato.",
        date: "August 21 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/cuanto-le-cuesta-a-un-restaurante-colombiano-no-tener-control-de-su-inventario",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/61bbbf1f-7df4-49c6-bd6f-e110b6f945f1.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },
      {
        id: 66,
        name: "Factura electrónica para restaurantes en Colombia: guía paso a paso", 
        description:
          "Aprende cómo funciona la facturación electrónica en Colombia, qué exige la DIAN y cómo una solución integral como INVU POS puede ayudarte a gestionar tu restaurante de forma más eficiente. Administrar un restaurante implica mucho más que preparar buenos platos y ofrecer un excelente servicio. También necesitas controlar las ventas, organizar los pedidos, gestionar los pagos, coordinar al equipo y cumplir con las obligaciones tributarias.",
          date: "October 22 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/factura-electronica-para-restaurantes-en-colombia-guia-paso-a-paso",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/Cajera%20en%20cafeter%C3%ADa%20acogedora%20con%20POS.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Colombia", 
      },  
  ];

  const sortedData = data.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
  const sortedFilteredData = filteredData
  ? filteredData.slice().sort((a, b) => new Date(b.date) - new Date(a.date))
  : null;

  const filterItems = () => {
    let filteredData;
  
    if (
      selectedCategory === "All" &&
      selectedTypeContent === "All" &&
      selectedCountry === "All"
    ) {
      // If all filters are "All", show all blogs
      filteredData = data;
    } else {
      // Apply filtering logic based on selected values
      filteredData = data.filter((item) => {
        const categoryCondition = selectedCategory === "All" || item.category === selectedCategory;
        const typeContentCondition = selectedTypeContent === "All" || item.typecontent === selectedTypeContent;
        const countryCondition =
          selectedCountry === "All" || (Array.isArray(item.countries) ? item.countries.includes(selectedCountry) : item.country === selectedCountry);
  
        return categoryCondition && typeContentCondition && countryCondition;
      });
    }
  
    setFilteredData(filteredData);
  
    if (filteredData.length === 0) {
      setErrorMessage(
        `No items found for ${selectedTypeContent} ${selectedCategory} ${selectedCountry}`
      );
    } else {
      setErrorMessage("");
    }
  };

  const resetFilter = () => {
    setSelectedCategory("All");
    setSelectedTypeContent("All");
    setSelectedCountry("All");
    setFilteredData(data);
    setErrorMessage("");
  };

  const uniqueCategories = [
    "All",
    ...new Set(data.map((item) => item.category)),
  ];
  const uniqueTypeContent = [
    "All",
    ...new Set(data.map((item) => item.typecontent)),
  ];

  const location = useLocation();
  const prefix = useLocalePrefix();
  const { t } = useTranslation();
  return (
    <>
      {isLoading && (
        <div class="fixed inset-0 flex items-center justify-center"> 
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#4fa94d"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      <section class="px-4 py-24 mx-auto max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8">
        <div class="w-full mx-auto text-left md:w-11/12 xl:w-9/12 md:text-center">
          <h2 className="mb-3 text-xs font-semibold tracking-widest text-black uppercase title-font text-pirGray-100">
            {t("ourbloguppercase")}
          </h2>
          <h1 class="mb-6 text-4xl font-extrabold leading-none tracking-normal text-gray-900 md:text-5xl md:tracking-tight">
            {t("ourblogtitle1")}{" "}
            <span class="block w-full text-transparent bg-clip-text bg-gradient-to-r from-[#FFCD00] via-[#003087] to-[#C8102E] lg:inline">
              {t("ourblogtitlespan")}
            </span>{" "}
            {t("ourblogtitle2")}
          </h1>
        </div>

        <div
          class="
                  p-2
                  mt-16
                  transition
                  duration-500
                  ease-in-out
                  transform
                  border2
                  bg-gray-50
                  md:mx-auto
                  rounded-xl
                  sm:max-w-5xl
                  lg:flex
                  mb-8
                "
        >
          <div class="lg:flex space-x-12">
            <div class="flex-1 min-w-0 revue-form-group">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                class="
                block
                w-full
                px-5
                py-3
                text-base text-neutral-600
                placeholder-gray-300
                transition
                duration-500
                ease-in-out
                transform
                bg-transparent
                border border-transparent
                rounded-md
                focus:outline-none
                focus:border-transparent
                focus:ring-2
                focus:ring-white
                focus:ring-offset-2
                focus:ring-offset-gray-300
              "
              >
                {/* {uniqueCategories.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))} */}
                <option value="All">{t("categoryblog1")}</option>
                <option value="Finances">{t("categoryblog2")}</option>
                {/* <option value="Payments">{t("categoryblog3")}</option> */}
                {/* <option value="Customers">{t("categoryblog4")}</option> */}
                <option value="Management">{t("categoryblog5")}</option>
                {/* <option value="Marketing">{t("categoryblog6")}</option> */}
                <option value="Press release">{t("categoryblog7")}</option>
                {/* <option value="Informative">{t("categoryblog8")}</option> */}
                {/* <option value="System POS">Sistema POS</option> */}
                <option value="Delivery">Delivery</option>
                {/* <option value="Educational">{t("categoryblog9")}</option> */}
              </select>
            </div>
            <div class="flex-1 min-w-0 revue-form-group">
              <select
                value={selectedTypeContent}
                onChange={(e) => setSelectedTypeContent(e.target.value)}
                class="
                block
                w-full
                px-5
                py-3
                text-base text-neutral-600
                placeholder-gray-300
                transition
                duration-500
                ease-in-out
                transform
                bg-transparent
                border border-transparent
                rounded-md
                focus:outline-none
                focus:border-transparent
                focus:ring-2
                focus:ring-white
                focus:ring-offset-2
                focus:ring-offset-gray-300
              "
              >
                {/* {uniqueTypeContent.map((typecontent) => (
                  <option key={typecontent} value={typecontent}>
                    {typecontent}
                  </option>
                ))} */}
                <option value="All">{t("typecontentblog1")}</option>
                <option value="Articles">{t("typecontentblog2")}</option>
                <option value="Guides">{t("typecontentblog3")}</option>
                {/* <option value="Tools">{t("typecontentblog4")}</option> */}
              </select>
            </div>
            <div class="flex-1 min-w-0 revue-form-group">
              <select
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
                class="
                block
                w-full
                px-5
                py-3
                text-base text-neutral-600
                placeholder-gray-300
                transition
                duration-500
                ease-in-out
                transform
                bg-transparent
                border border-transparent
                rounded-md
                focus:outline-none
                focus:border-transparent
                focus:ring-2
                focus:ring-white
                focus:ring-offset-2
                focus:ring-offset-gray-300"
              >
                <option value="All">Todos los países</option>
                {/* <option value="Panama">Panamá</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Mexico">México</option> */}
                <option value="Colombia">Colombia</option>
              </select>
            </div>

          </div>
          <div class="mt-4 sm:mt-0 lg:ml-3 revue-form-actions">
            <button
              onClick={() => {
                filterItems();
                handleFilterButtonClick();
              }}
              class="
               block
               w-full
               px-5
               py-3
               text-base
               text-white
               bg-indigo-600
               border border-transparent
               rounded-lg
               shadow
               font-semibold
               hover:bg-indigo-700
               focus:outline-none
               focus:ring-2
               focus:ring-white
               focus:ring-offset-2
               focus:ring-offset-gray-300
               sm:px-10
             "
            >
              {t("filtersearchblogbutton")}
            </button>
          </div>
        </div>

        {/* <div class="grid grid-cols-1 mt-24 gap-12 md:grid-cols-2 lg:grid-cols-2 ">
          <div>
            <Link
              onClick={() => window.scrollTo(0, 0)}
              class="block"
              to={`${prefix}` + "/blog/programas-de-contabilidad-en-la-nube"}
            >
              <img
                class="object-cover w-full h-82 shadow-xl rounded-xl"
                src="https://img.invupos.com/webinvu/Blog%20invu/Blog%2021/Cover%20blog%2021%20.jpeg"
                alt=""
              />

              <div class="mt-10">
                <div class="h-full flex items-start">
                  <div class="w-12 flex-shrink-0 flex flex-col text-center leading-none">
                    <span class="text-gray-500 pb-2 mb-2 border-b-2 border-gray-200">
                      Jul
                    </span>
                    <span class="font-medium text-lg text-gray-800 title-font leading-none">
                      07
                    </span>
                  </div>
                  <div class="flex-grow pl-6">
                    <h2 class="tracking-widest text-xs title-font font-medium text-indigo-500 mb-1 uppercase">
                      Destacado
                    </h2>
                    <h1 class="title-font max-w-md text-xl font-semibold text-gray-900 mb-3">
                      Software de contabilidad y facturación en la nube
                    </h1>
                    <p class="mt-2 max-w-lg text-gray-600 ">
                      A día de hoy, y gracias al avance de la tecnología, los
                      softwares de contabilidad en la nube se han convertido en
                      muy valiosas herramientas de trabajo para los
                      departamentos de contabilidad de las empresas.
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div>
            <Link
              class="block"
              onClick={() => window.scrollTo(0, 0)}
              to={`${prefix}` + "/blog/facturacion-electronica-dgi-2022"}
            >
              <img
                class="object-cover w-full h-82 shadow-xl rounded-xl"
                src="https://img.invupos.com/webinvu/Blog%20invu/Blog%2022/Cover%20blog%2022%20.jpeg"
                alt=""
              />

              <div class="mt-10">
                <div class="h-full flex items-start">
                  <div class="w-12 flex-shrink-0 flex flex-col text-center leading-none">
                    <span class="text-gray-500 pb-2 mb-2 border-b-2 border-gray-200">
                      Jul
                    </span>
                    <span class="font-medium text-lg text-gray-800 title-font leading-none">
                      08
                    </span>
                  </div>
                  <div class="flex-grow pl-6">
                    <h2 class="tracking-widest text-xs title-font font-medium text-indigo-500 mb-1">
                      DESTACADO
                    </h2>
                    <h1 class="title-font max-w-md text-xl font-semibold text-gray-900 mb-3">
                      Facturación electrónica en Panamá: requisitos y novedades
                    </h1>
                    <p class="mt-2 max-w-lg text-gray-600 ">
                      En Panamá, la factura electrónica es un modelo de
                      facturación que, además de reemplazar el uso de impresoras
                      fiscales, acelera la transformación digital de las
                      empresas e impulsa el ingreso de los emprendedores en la
                      economía formal.
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div> */}
      </section>
      {showButton && (
        <>
          <button
            onClick={handleScrollToTop}
            class="fixed bottom-0 right-0 m-4 p-2 group flex items-center justify-between gap-4 rounded-lg border border-indigo-600 bg-indigo-600 px-5 py-3 transition-colors hover:bg-indigo-700 focus:outline-none focus:ring"
          >
            <span class="font-medium text-white transition-colors group-hover:text-white group-active:text-indigo-500">
              {t("fixedbuttonscroll")}
            </span>

            <span class="flex-shrink-0 rounded-full border border-current bg-white p-2 text-indigo-600 group-active:text-indigo-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </button>
        </>
      )}
      <section id="results-section" className="bg-gray-100">
        <div className="px-4 py-24 mx-auto max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8">
          <h1 className="-mt-8 text-4xl font-bold xl:block hidden leading-tight text-gray-800">
            {t("titlelistblog")}
          </h1>
          <span class="block w-24 h-2 mt-1 xl:block hidden  bg-gradient-to-r from-pirLightBlue to-pirPurple hover:from-pirPink hover:to-pirOrange "></span>

          <h1 className="-mt-8 text-3xl mb-4 font-bold xl:hidden block leading-tight lg:leading-10 text-gray-800">
            {t("titlelistblog")}
          </h1>
          <span class="block w-24 h-2 mt-1 lg:invisible  bg-gradient-to-r from-pirLightBlue to-pirPurple hover:from-pirPink hover:to-pirOrange "></span>
          <div>
            {" "}
            {errorMessage && (
              <>
                <div class="rounded-3xl mt-8 shadow-2xl">
                  <div class="p-8 text-center sm:p-12">
                    <p class="text-sm font-semibold uppercase tracking-widest text-indigo-500">
                      {t("errormessageblogs")}
                    </p>

                    <h2 class="mt-6 text-3xl font-bold">{errorMessage}</h2>

                    <button
                      class="mt-8 inline-block lg:w-96 md:w-96 w-52 rounded-full bg-indigo-600 py-4 text-lg font-bold text-white transition hover:scale-110 hover:shadow-xl focus:outline-none focus:ring active:bg-indigo-500"
                      onClick={resetFilter}
                    >
                      {t("buttonrefreshblogs")}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="grid gap-6  grid-cols-1 mt-8 grid grid-cols-1 gap-12 md:grid-cols-2  lg:grid-cols-2 xl:grid-cols-3">
            {!filteredData
              ? sortedData.map((item, index) => (
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    to={`${prefix}` + item.href}
                    key={index}
                  >
                    <div className="overflow-hidden transition-shadow duration-300 bg-white rounded">
                      <a aria-label="Article">
                        <img
                          src={item.imageSrc}
                          className="object-cover w-full h-64 rounded-t-lg"
                          alt=""
                        />
                      </a>
                      <div className="py-5 p-6">
                        <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-sm text-purple-700">
                          {item.typecontent}
                        </span>
                        <div className="flex justify-between items-end mt-3">
                          {item.countries && Array.isArray(item.countries) ? (
                            <p className="mb-2 text-xs font-semibold text-gray-600 uppercase">
                              {item.date} | {item.countries.join(', ')}
                            </p>
                          ) : (
                            <p className="mb-2 text-xs font-semibold text-gray-600 uppercase">
                              {item.date} | {item.country}
                            </p>
                          )}
                        </div>
                        <a
                          aria-label="Article"
                          className="inline-block mt-2.5 mb-3 text-black transition-colors duration-200 hover:text-deep-purple-accent-700"
                        >
                          <p className="text-2xl font-bold leading-7">
                            {item.name.length > 72
                              ? `${item.name.substring(0, 72)}...`
                              : item.name}
                          </p>
                        </a>
                        <p className="mb-4 text-gray-700">
                          {item.description.length > 240
                            ? `${item.description.substring(0, 238)}...`
                            : item.description}
                        </p>
                        <div class="mt-1.5 sm:mt-0">
                          <p class="text-gray-500 italic text-sm">{item.category}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))
                : sortedFilteredData.map((item, index) => (
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    to={`${prefix}` + item.href}
                    key={index}
                  >
                    <div className="overflow-hidden transition-shadow duration-300 bg-white rounded">
                      <a aria-label="Article">
                        <img
                          src={item.imageSrc}
                          className="object-cover w-full h-64 rounded-t-lg"
                          alt=""
                        />
                      </a>
                      <div className="py-5 p-6">
                      <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-sm text-purple-700">
                          {item.typecontent}
                        </span>
                        <div className="flex justify-between items-end mt-3">
                          {item.countries && Array.isArray(item.countries) ? (
                            <p className="mb-2 text-xs font-semibold text-gray-600 uppercase">
                              {item.date} | {item.countries.join(', ')}
                            </p>
                          ) : (
                            <p className="mb-2 text-xs font-semibold text-gray-600 uppercase">
                              {item.date} | {item.country}
                            </p>
                          )}
                        </div>
                        <a
                          aria-label="Article"
                          className="inline-block mt-2.5 mb-3 text-black transition-colors duration-200 hover:text-deep-purple-accent-700"
                        >
                          <p className="text-2xl font-bold leading-7">
                            {item.name.length > 72
                              ? `${item.name.substring(0, 72)}...`
                              : item.name}
                          </p>
                        </a>
                        <p className="mb-4 text-gray-700">
                          {item.description.length > 240
                            ? `${item.description.substring(0, 238)}...`
                            : item.description}
                        </p>
                        <div class="mt-1.5 sm:mt-0">
                          <p class="text-gray-500 italic text-sm">{item.category}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogCL;
